<template>
  <div class="py-2 px-6">
    <div class="flex justify-between mx-3 my-7">
      <div class="flex"><logo-icon></logo-icon></div>
      <div class="cursor-pointer lowercase text-primary">
        <p>www.{{ tenantName }}.com</p>
      </div>
    </div>
    <div class="mt-2 p-4">
      <div class="my-4">
        <span class="font-bold">Business Name:</span> <br />
        <span>{{ business.name }}</span>
      </div>
      <div class="my-4">
        <span class="font-bold">Email:</span> <br />
        <span>{{ business.email }}</span>
      </div>
      <div class="border border-gray-14 p-4 my-6 rounded-md shadow-md">
        <div class="font-bold mb-4 text-base">
          Account Details (
          {{
            wireTransferType
              ? wireTransferType
              : isGBPDeposit
              ? 'Bank Details'
              : 'Within The United States'
          }}
          )
        </div>
        <div>
          <p class="my-2">
            Amount:
            <span class="font-medium mr-1">
              {{ parseAmount(transactionDetails.amount.amount) }}
              {{ transactionDetails.amount.currency }}</span
            >
          </p>
          <p class="my-2">
            Account Number:
            <span class="font-medium mr-1">
              {{ downloadDetails.accountNumber }}</span
            >
          </p>
          <div v-if="isGBPDeposit">
            <p class="my-2">
              IBAN:
              <span class="font-medium mr-1">
                {{ downloadDetails.iban || '--' }}
              </span>
            </p>
            <p class="my-2">
              Sort Code:
              <span class="font-medium mr-1">
                {{ downloadDetails.sortCode || '--' }}
              </span>
            </p>
          </div>
          <div v-else>
            <p v-if="valueExists(downloadDetails.bankPhone)" class="my-2">
              Bank Phone:
              <span class="font-medium mr-1">
                {{ downloadDetails.bankPhone }}
              </span>
            </p>

            <p v-if="valueExists(downloadDetails.bankAddress)" class="my-2">
              Bank Address:
              <span class="font-medium mr-1"
                >{{ downloadDetails.bankAddress }}
              </span>
            </p>

            <p
              v-if="valueExists(downloadDetails.beneficiaryAddress)"
              class="my-2"
            >
              Beneficiary Address:
              <span class="font-medium mr-1">
                {{ downloadDetails.beneficiaryAddress }}
              </span>
            </p>

            <p v-if="valueExists(downloadDetails.creditTo)" class="my-2">
              Credit to:
              <span class="font-medium mr-1">
                {{ downloadDetails.creditTo }}</span
              >
            </p>

            <p
              v-if="valueExists(downloadDetails.depositoryBankName)"
              class="my-2"
            >
              Depository Bank Name:
              <span class="font-medium mr-1">
                {{ downloadDetails.depositoryBankName }}</span
              >
            </p>

            <p v-if="valueExists(downloadDetails.reference)" class="my-2">
              Reference:
              <span class="font-medium mr-1">
                {{ downloadDetails.reference }}</span
              >
            </p>

            <p v-if="valueExists(downloadDetails.routingNumber)" class="my-2">
              Routing Number:
              <span class="font-medium mr-1">
                {{ downloadDetails.routingNumber }}
              </span>
            </p>

            <p v-if="valueExists(downloadDetails.swiftCode)" class="my-2">
              Swift Code:
              <span class="font-medium mr-1">
                {{ downloadDetails.swiftCode }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <div class="italic font-semibold">Disclaimer</div>
        <div style="word-break: normal" class="italic text-black-2 text-xs">
          This document is strictly confidential communication to and solely for
          the use of the recipient and may not be reproduced or circulated
          without {{ tenantName }} prior written consent. If you are not
          intended recipient, you may not disclose or use the information in
          this documentation in any way.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ParseAmount } from '@/utils/helpers.js'
export default {
  data () {
    return {
      wireTransferDetails: {}
    }
  },
  props: {
    transferType: {
      type: String,
      default: ''
    },
    terminalWireTransferDetails: {
      type: Object
    }
  },
  components: {
    logoIcon: () => import('@/assets/images/AppLogo.vue')
  },
  methods: {
    valueExists (val) {
      return val && val.length > 0
    },
    parseAmount (amount) {
      return ParseAmount(amount)
    }
  },
  computed: {
    tenantName () {
      return process.env.VUE_APP_TENANT_TITLE
    },
    isGBPDeposit () {
      return !!(
        this.transactionDetails.depositedAmount &&
        this.transactionDetails.depositedAmount.currency === this.$CURRENCY.GBP
      )
    },
    downloadDetails () {
      return this.wireTransferType === 'Within The United States'
        ? this.wireInstruction
        : this.wireInstructionIntl
    },
    transactionDetails () {
      return this.$store.state.transactions.transactionDetails
    },
    transactionType () {
      return (
        this.transactionDetails.transactionType ||
        this.$store.state.transactions.fundAccountActiveView
      )
    },
    wireInstructionIntl () {
      return this.transactionType === 'deposit'
        ? this.transactionDetails.transferInstruction.wireInstructionIntl
        : this.transactionDetails.transferInstruction.account_details
            .wireInstructionIntl
    },
    wireInstruction () {
      return this.transactionType === 'deposit'
        ? this.transactionDetails.transferInstruction.wireInstruction
        : this.transactionDetails.transferInstruction.account_details
            .wireInstruction
    },
    wireTransferType () {
      return this.$store.state.transactions.wireTransferType
    },
    business () {
      return this.$store.state.auth.business
    }
  }
}
</script>

<style scoped></style>
